import {Base} from "@/api/Base"

export class LeaveApproveNew extends Base {
    path = "leave/approveNew"
}